import { useState } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import "../../../common/common-css/CommonCss.css";
import Form_Header from "../../../common/form-header/Form_Header";
import Select from "react-select";
import "./Create_Step1.css";
import "react-phone-input-2/lib/style.css";

const Create_Step1 = ({ step, totalSteps, setStep }) => {
  const designationOptions = [
    { value: "Proprietor", label: "Proprietor" },
    { value: "Managing Partner", label: "Managing Partner" },
    { value: "director", label: "Director" },
  ];
  const progressWidth = (step / totalSteps) * 100;
  const [phone, setPhone] = useState("");
  const { control, handleSubmit } = useForm();
  return (
    <section className="step1_wrapper">
      <Form_Header
        title="Authorized Signatory Details (KYC)"
        subtitle=""
        step={1}
        totalSteps={6}
      />

      <div className="container">
        <Form className="auth_form">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" placeholder="Enter First Name" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" placeholder="Enter Last Name" />
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Designation in Business</Form.Label>
                <Select
                  options={designationOptions}
                  placeholder="Select designation"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-4">
              <Form.Group className="mb-3">
                <Form.Label>Contact</Form.Label>
                <Controller
                  name="contact"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Contact number is required" }}
                  render={({ field }) => (
                    <PhoneInput
                      country="in"
                      value={field.value}
                      onChange={field.onChange}
                      enableSearch
                      specialLabel=""
                      countryCodeEditable={true} // ✅ allows dropdown country code
                      inputClass="phone_input"
                      containerClass="phone_container"
                      buttonClass="phone_flag_btn"
                    />
                  )}
                />
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-4">
              <Form.Group>
                {" "}
                <Form.Label>date of Birth</Form.Label>{" "}
                <Form.Control type="date" />{" "}
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-4">
              <Form.Group className="mb-4">
                <Form.Label>Personal Email Id</Form.Label>
                <Form.Control type="email" placeholder="Enter Email" />
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Enter Password" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Re-Enter Password</Form.Label>
                <Form.Control type="password" placeholder="Confirm Password" />
              </Form.Group>
            </div>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Enter Residential Address"
              />
            </Form.Group>
            <div className="col-lg-6 mt-4 ">
              <Form.Group>
                <Form.Label>Bank Name</Form.Label>
                <Form.Control type="text" placeholder="Enter Bank Name" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mt-4 ">
              <Form.Group>
                <Form.Label>
                  Account Holder Name (Must match Business Legal Name)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Account Holder Name"
                />
              </Form.Group>
            </div>

            <div className="col-lg-6 mt-4 ">
              <Form.Group>
                <Form.Label>Account Number</Form.Label>
                <Form.Control type="text" placeholder="Enter Account Number" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mt-4 ">
              <Form.Group>
                <Form.Label>IFSC Code</Form.Label>
                <Form.Control type="text" placeholder="Enter IFSC Code" />
              </Form.Group>
            </div>

            <div className="form_btn_holder">
              <Common_Btn btnText={"Next"} onClick={() => setStep(2)} />
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default Create_Step1;
